<template>
  <div class="login align-center">
    <div class="title mtb10">{{ title }}</div>
    <login
        v-if="title === '用户登录'"
        ref="lform"
        :codeUrl="codeUrl"
        @getCode="getCode"
        @toggle="toggle"/>
    <Sign-in
        v-if="title === '用户注册'"
        ref="lform"
        :codeCd="codeCd"
        :long="long"
        :codeUrl="codeUrl"
        @getCode="getCode"
        @toggle="toggle"
        @getcodeCd="getcodeCd"
        @agreementClick="dialogVisible = true"
    />
    <ForgotPassword
        v-if="title === '找回密码'"
        ref="lform"
        :codeCd="codeCd"
        :long="long"
        :codeUrl="codeUrl"
        @getCode="getCode"
        @getcodeCd="getcodeCd"
        @toggle="toggle"/>
    <el-dialog title="注册协议" :visible.sync="dialogVisible" :width="dialogWidth">
      <div v-html="registrationAgreement"></div>
    </el-dialog>
  </div>
</template>
<script>
import Login from "@/views/Login/components/login.vue";
import SignIn from "@/views/Login/components/Sign-in.vue";
import ForgotPassword from "@/views/Login/components/Forgot-password.vue";
import {sendapi, sendVerificationCode} from "@/api/api";
import {baseApi} from '@/utils/request.js'

export default {
  components: {ForgotPassword, SignIn, Login},
  props: {
    name: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      title: "用户登录",
      loading: false,
      // 验证码是否CD
      codeCd: false,
      // CD长度
      long: 15,
      checked: false,
      // 验证码开关
      captchaEnabled: true,
      codeUrl: "",
      registrationAgreement: '', // 注册协议
      dialogVisible: false,
      //给弹出框设置宽度，判断当前是移动端还是pc端
      dialogWidth: document.body.clientWidth < 750 ? '90%' : '60%',
    }
  },
  watch: {
    name: function (val) {
      if (val === '注册') {
        this.title = '用户注册';
      } else if (val === '登录') {
        this.title = '用户登录';
      }
    }
  },
  mounted() {
    this.getCode() // 获取图形验证码
  },
  methods: {
    // 注册
    toggle(e) {
      this.title = e;
    },
    // 开始倒计时
    startCountdown() {
      this.long = 60;
      const interval = setInterval(() => {
        if (this.long > 0) {
          this.long--;
        } else {
          clearInterval(interval);
          this.codeCd = false;
        }
      }, 1000);
    },
    // 发送手机号短信验证码
    async getcodeCd(mobile) {
      if (mobile && /^1[3456789]\d{9}$/.test(mobile)) {
        try {
          let event = this.title === '用户注册' ? 'register' : 'resetpwd'
          const response = await sendapi({
            mobile: mobile,
            event: event, // 验证码场景：register 注册，login 登录，resetpwd 重置密码
          }); //sendVerificationCode
          if (response.status === 200) {
            this.codeCd = true;
            this.startCountdown();
             this.$message.success('验证码发送成功')
          } else {
            this.$message.warning('验证码发送失败，请稍后再试')
          }
        } catch (error) {
          // this.$message.error('请求出错，请检查网络连接')
        }
      } else {
        this.$message.warning('请输入正确的手机号')
      }
    },
    // 获取图形验证码
    getCode() {
      fetch(baseApi + '/api/user/captcha')
          .then(response => response.blob()) // 获取 Blob 对象
          .then(blob => {
            const url = URL.createObjectURL(blob); // 创建 URL 对象
            this.codeUrl = url;
          });
    },
  }
}
</script>
<style scoped lang="scss">
.login {
  min-height: 385px;
  padding: 20px 50px;
  background: #FFFFFF;
  border-radius: 10px 10px 10px 10px;

  .title {
    font-weight: bold;
    font-size: 16px;
    color: #C32912;
    line-height: 19px;
  }
}

@media (max-width: 750px) {

}
</style>
